module.exports = __webpack_public_path__ + "static/media/ic_search.91325e55.svg";